import { render, staticRenderFns } from "./EmailTransferDetail.vue?vue&type=template&id=2ee95022&scoped=true&"
import script from "./EmailTransferDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailTransferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTransferDetail.vue?vue&type=style&index=0&id=2ee95022&scoped=true&lang=css&"
import style1 from "./EmailTransferDetail.vue?vue&type=style&index=1&id=2ee95022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee95022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
